import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fairway_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.message) return detail.message;
  if (detail?.msg) return detail.msg;
  return String(detail);
}

/** True when the API error is a Pro-gate (backend returned `pro_required: true`). */
export function isProRequired(err) {
  const detail = err?.response?.data?.detail;
  return err?.response?.status === 403 && detail && typeof detail === "object" && detail.pro_required === true;
}

// Auto-redirect to /subscribe when the backend sends pro_required — gives a
// consistent UX across every locked feature without each page rolling its own.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (isProRequired(err)) {
      const msg = err?.response?.data?.detail?.message || "Fairway Pro is needed for this.";
      try { sessionStorage.setItem("fairwayProToast", msg); } catch { /* private mode */ }
      if (!window.location.pathname.startsWith("/subscribe")) {
        window.location.href = "/subscribe";
      }
    }
    return Promise.reject(err);
  },
);
